module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_16-27d1555d38b29071cf263a44b6cbbd30.jpg";